import React from "react";
import { Formik } from "formik";
import { TextField } from "@material-ui/core";

import { appRoutes } from "routes";
import { useRouter, useUsers } from "hooks";
import AccountLayout from "layouts/AccountLayout";
import UserPresenter from "presenters/UserPresenter";
import { initialValues, validationSchema } from "forms/ChangeNameForm";
import MetaTags from "components/MetaTags";

import { CancelButton, InputPlaceholder, Title, SaveButton } from "../components";

import useStyles from "./useStyles";

const ChangeName = () => {
  const classes = useStyles();
  const { push } = useRouter();
  const { currentUser, updateUser } = useUsers();

  const handleSubmit = (values, formikBag) => {
    const params = {
      data: {
        attributes: { "first-name": values.name },
        type: "users",
      },
    };
    return updateUser(params).then(
      () => {
        push(appRoutes.myAccountPath());
      },
      (error) => {
        formikBag.setFieldError("name", error.response.data.errors[0].detail);
      },
    );
  };

  return (
    <>
      <AccountLayout title="Funny eCards - Send Custom Greeting Cards Online w/ JibJab! - My Account - Edit Name">
        <Title title="Edit Name" subtitle="Change your name below" />

        {currentUser ? (
          <Formik
            initialValues={initialValues(UserPresenter.firstName(currentUser))}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <form onSubmit={formik.handleSubmit} className={classes.form}>
                <TextField
                  margin="normal"
                  placeholder="Name"
                  id="name"
                  helperText={formik.touched.name && formik.errors.name}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  {...formik.getFieldProps("name")}
                />

                <SaveButton>Update Name</SaveButton>
              </form>
            )}
          </Formik>
        ) : (
          <InputPlaceholder />
        )}

        <CancelButton />
      </AccountLayout>
      <MetaTags>
        <meta
          name="og:description"
          content="Personalized eCards from JibJab for every occasion. Browse, customize, send funny greeting cards online for birthdays, holidays, valentines, thank yous & more!"
        />
      </MetaTags>
    </>
  );
};

export default ChangeName;
